import { 
    API_ENDPOINTS,  
    route,
    SelectOption,  
} from "carrier-fe";
import { ToshibaInstallationFormData } from "../pages/installation/toshiba/journey";
import { STEPS } from "./Constants";
import axios from 'axios';

export const generateProductKey = (): string => {
    return `temp_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
};

export const configureToshibaPayload = (
    data: Partial<ToshibaInstallationFormData>,
    activeStep: number
): Partial<ToshibaInstallationFormData> => {
    const stepsPayloads: Record<number, Partial<ToshibaInstallationFormData>> = {
        [STEPS.STEP_1]: {
            installer_company_id: data.installer_company_id,
            installer_user_id: data.installer_user_id,
        },
        [STEPS.STEP_2]: {
            product_parent_id: data.product_parent_id,
            skip_step_5: data.skip_step_5,
        },
        [STEPS.STEP_3]: {
            product_child_id: data.product_child_id,
        },
        [STEPS.STEP_4]: {
            commissioning_date: data.commissioning_date,
            distributor_id: data.distributor_id,
            customer_id: data.customer_id,
        },
        [STEPS.STEP_5]: {
            products: data.products,
            total_system_refrigerant: data.total_system_refrigerant,
            add_a2a: data.add_a2a,
        },
        [STEPS.STEP_6]: {
            additional_a2a: data.additional_a2a,
        }
    };

    if (data.skip_step_5 && activeStep === STEPS.STEP_5) {
        return stepsPayloads[STEPS.STEP_6]
    }

    return stepsPayloads[activeStep];
};

export const fetchProductLines = async (
    { childId, typeId, setDisabled }: {
        childId?: string;
        typeId?: string;
        setDisabled?: (value: boolean) => void;
    } = {}
) => {
    if (setDisabled) setDisabled(true);

    try {
        const response = await axios.get<{ data: SelectOption[] }>(
            route(
                API_ENDPOINTS.GENERIC.SELECT.PRODUCT.LINES, {
                    ...childId && {
                        product_child_id: childId
                    },
                    ...typeId && {
                        product_type_id: typeId
                    },
                }
            )
        );

        return response?.data?.data;
    } catch (error: any) {
        throw error;
    } finally {
        if (setDisabled) setDisabled(false);
    }
};

export const fetchProductModels = async (
    { childId, typeId, lineId, setDisabled }: {
        childId?: string;
        typeId?: string;
        lineId?: string;
        setDisabled?: (value: boolean) => void;
    } = {}
) => {
    if (setDisabled) setDisabled(true);

    try {
        const response = await axios.get<{ data: SelectOption[] }>(
            route(
                API_ENDPOINTS.GENERIC.SELECT.PRODUCT.MODELS, {
                    ...childId && {
                        product_child_id: childId
                    },
                    ...typeId && {
                        product_type_id: typeId
                    },
                    ...lineId && {
                        product_line_id: lineId
                    }
                }
            )
        );

        return response?.data?.data;
    } catch (error: any) {
        throw error;
    } finally {
        if (setDisabled) setDisabled(false);
    }
};